<template>
  <span :id="instanceId" :name="instanceId" style="padding-left: 2px;">
    <span class="icon has-text-info is-clickable" v-if="isCustomerSyncing">
      <i v-tooltip="'Resync Crm Customer'" class="fas fa-sync-alt fa-spin fa-lg" ></i>
    </span>
    <span @click.stop.prevent="syncCustomer" v-else>
      <i class="fa-fw fal fa-sync fa-sm clickable has-text-success" v-tooltip="'Resync Crm Customer'"/>
    </span>
  </span>
</template>

<script>
import dealerPeakService from '@/services/dealerPeakService'
import utilitiesMixin from '@/mixins/generic/utilities'

export default {
  name: 'DealerPeakCustomerResyncComponent',
  mixins: [utilitiesMixin],
  props: {
    id: {
      type: Number,
      default: 0
    },
    mobile: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      customerId: this.id,
      instanceId: this.$uuid.v4(),
      isCustomerSyncing: false,
      customerMobile: this.mobile,
      customerEmail: this.email,
      customerSyncSuccessful: false
    }
  },
  components: {
  },
  computed: {
  },
  methods: {
    syncCustomer: async function () {
      this.customerSyncSuccessful = false
      this.isCustomerSyncing = true
      let model = {
        number: this.unmask(this.customerMobile),
        email: this.customerEmail,
        customerType: 'Lead',
        customerId: this.customerId,
        source: 'LIVE',
        clearExistingLeads: true,
        openLeadsOnly: true
      }
      try {
        await dealerPeakService.syncCustomer(model)
        this.isCustomerSyncing = false
        this.successToast('Customer Resynced to Crm')
        this.customerSyncSuccessful = true
      } catch (err) {
        this.isCustomerSyncing = false
        this.failedToast('Error when resyncing customer: ' + err)
      }
    }
  },
  watch: {
    id: function (newValue, oldValue) {
      if (newValue) {
        this.customerId = newValue 
      }
    },
    mobile: function (newValue, oldValue) {
      if (newValue) {
        this.customerMobile = newValue
      }
    },
    email: function (newValue, oldValue) {
      if (newValue) {
        this.customerEmail = newValue
      }
    }
  },
  mounted () {
  }
}

</script>

<style scoped>
  .content ul{
    list-style-type: none;
    margin-top: 0
  }

  .modal-card-head, .modal-card-foot{
    padding: 20px !important
  }

  .vauto-status-container {
    margin-top: 20px;
    padding: 0;
    margin-left: 0;
    margin-right: 0;
  }

  .vauto-container-display-only {
    display: inline-flex;
    flex-flow: row;
    align-items: center;
    margin-top:10px;
  }

  .modal-fullscreen .modal-card {
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    position: fixed;
    z-index: 100000;
    max-height: 100% !important;
  }

  .modal-card-body {
    overflow:auto;
    height: calc(110vh - 350px);
  }

</style>
